import React from 'react';
import Victual from '../../Victual/Victual';

export default () => {
  return (
    <div className='list'>
      <h2 id='maki'>Maki</h2>
      <Victual name='Tuna Maki' 
      desc='Tuna rolled with rice'
      price='1.0'/>
      <Victual name='Salmon Maki' 
      desc='Lorum ipsum'
      price='1.1'/>
      <Victual name='Unagi Maki' 
      desc='Lorum ipsum'
      price='1.2'/>
      <Victual name='Kimchi Tuna' 
      desc='Lorum ipsum'
      price='1.5'/>
      <Victual name='Grilled Tuna' 
      desc='Lorum ipsum'
      price='1.1'/>
      <Victual name='Grilled Salmon' 
      desc='Lorum ipsum'
      price='1.1'/>
      <Victual name='Smoked Salmon' 
      desc='Lorum ipsum'
      price='1.2'/>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Menu/Categories/Maki/Maki.js